import PrecatoriosAltoValor from './PrecatoriosAltoValor/PrecatoriosAltoValor';

export default PrecatoriosAltoValor;